<template>
    <v-card-title
        class="pa-1"
        :style="$vuetify.theme.dark ? 'background-color: #1e1f22' : 'background-color: white'"
        style="min-height: 92px"
        :class="$vuetify.breakpoint.width <= 430 ? 'py-0' : ''"
    >
        <v-container class="px-0" style="min-height: 97px">
            <!--            <v-row-->
            <!--                v-if="$vuetify.breakpoint.width <= 940 && event.mId !== $const.DBALL_MARKET_LIVE"-->
            <!--                class="mx-0 pl-2 pt-2"-->
            <!--            >-->
            <!--                <v-icon size="18" style="padding-right: 2px">mdi-calendar-clock-outline</v-icon>-->
            <!--                <span-->
            <!--                    v-if="event && event.dg"-->
            <!--                    class="font13 grey&#45;&#45;text"-->
            <!--                    :class="$vuetify.breakpoint.width <= 430 ? 'mr-8' : ''"-->
            <!--                    >{{ event.dg | formatInTimeZone('dd MMM H:mm', true) }}-->
            <!--                    <span class="date-remaining">{{-->
            <!--                        utils.getDateRemaining(event.leftUntilStart, user.timeZone)-->
            <!--                    }}</span></span-->
            <!--                >-->
            <!--            </v-row>-->

            <v-row v-if="event.clName" class="mx-0 pl-2">
                <img
                    v-if="event.iso3"
                    :alt="event.iso3"
                    :src="'/images/flags/countries/' + event.iso3 + '.png'"
                    width="16px"
                    height="16px"
                    style="margin-top: 5px"
                />
                <img v-else alt="world" :src="'/images/flags/countries/world.png'" width="16px" height="16px" style="margin-top: 5px" />
                <span class="px-1 font14 greyText font-weight-regular">
                    {{ event.clName }}
                </span>
                <v-btn tag="a" icon x-small @click="toggleFavoriteLeague(event)" :disabled="event.clId in favoriteLeagueProcessing">
                    <v-icon size="24px" v-if="!(event.clId in favoriteLeague)" color="grey lighten-1" class="mt-1">mdi-star-outline</v-icon>

                    <v-icon size="24px" v-else color="yellow darken-3" class="mt-1">mdi-star</v-icon>
                </v-btn>

                <!--                <v-spacer></v-spacer>-->

                <!--                <v-icon-->
                <!--                    v-if="$vuetify.breakpoint.width > 940 && event.mId !== $const.DBALL_MARKET_LIVE"-->
                <!--                    size="18"-->
                <!--                    style="padding-right: 2px"-->
                <!--                    >mdi-calendar-clock-outline</v-icon-->
                <!--                >-->
                <!--                <span-->
                <!--                    v-if="-->
                <!--                        $vuetify.breakpoint.width > 940 && event && event.dg && event.mId !== $const.DBALL_MARKET_LIVE-->
                <!--                    "-->
                <!--                    class="font13 grey&#45;&#45;text pr-2"-->
                <!--                    :class="$vuetify.breakpoint.width <= 430 ? 'mr-8' : ''"-->
                <!--                    >{{ event.dg | formatInTimeZone('dd MMM H:mm', true) }}</span-->
                <!--                >-->
            </v-row>

            <v-row class="mx-0 mt-4">
                <v-col class="pa-0 d-flex align-center justify-center flex-row">
                    <v-btn tag="a" class="mr-2" icon x-small @click="toggleFavoriteTeam('cthId', event)" :disabled="event.cthId in favoriteTeamProcessing">
                        <v-icon size="24px" v-if="!(event.cthId in favoriteTeam)" color="grey lighten-1">mdi-star-outline</v-icon>

                        <v-icon size="24px" v-else color="yellow darken-3">mdi-star</v-icon>
                    </v-btn>
                    <img v-if="event.cthLogo" :src="'/teams/' + event.cthLogo" class="logo" alt="team" />
                    <img v-else src="https://cdn.sportmonks.com/images/soccer/team_placeholder.png" class="logo" alt="team" />
                </v-col>
                <v-col class="pt-4 px-0" :style="'max-width:' + scoreWidth">
                    <v-row class="ma-0 pa-0 d-flex flex-column align-center justify-center">
                        <span
                            v-if="event.mId === $const.DBALL_MARKET_LIVE"
                            data-tooltip-position="right"
                            @mouseleave="utils.hideTooltip('tooltip-event')"
                            @mouseenter="
                                !eventStats.time
                                    ? utils.showTooltip($event, $t('feed.unavailableTooltip'), true, 'tooltip-event')
                                    : utils.showTooltip(
                                          $event,
                                          utils.listSiteDataQtip(JSON.parse(eventStats.times), event.clId, event.clLCId),
                                          false,
                                          'tooltip-event'
                                      )
                            "
                            :class="[!eventStats.time ? 'redText' : eventStats.time === 'FT' ? 'ft-time' : 'time', 'bold']"
                            v-html="getTime(eventStats)"
                        ></span>
                        <span
                            v-else-if="event.dg"
                            :class="$vuetify.breakpoint.width <= 945 ? ($vuetify.breakpoint.width <= 660 ? 'font10' : 'font13') : 'font13'"
                        >
                            {{ formatDballDate(event.dg) }}
                        </span>
                    </v-row>
                    <v-row class="ma-0 pa-0 pt-1 d-flex flex-column align-center justify-center">
                        <span v-if="event.mId === $const.DBALL_MARKET_LIVE">
                            <span
                                data-tooltip-position="right"
                                @mouseleave="utils.hideTooltip('tooltip-event')"
                                @mouseenter="
                                    !eventStats.score
                                        ? utils.showTooltip($event, $t('feed.unavailableTooltip'), true, 'tooltip-event')
                                        : utils.showTooltip(
                                              $event,
                                              utils.listSiteDataQtip(JSON.parse(eventStats.scores), event.clId, event.clLCId),
                                              false,
                                              'tooltip-event'
                                          )
                                "
                                class="bold"
                            >
                                <!--                        <span class="font10" v-if="item.scDiff">&nbsp;&nbsp; </span>-->
                                <span v-html="getScore(eventStats)" :class="[eventStats.time === 'FT' ? 'ft-score' : 'score']"></span>
                                <!--                        <span class="font10 redText" v-if="item.scDiff"> ?</span>-->
                            </span>
                            <!--                            <span v-else class="time bold font10">{{ $t('feed.scoreNotConfirmed') }}</span>-->
                        </span>
                        <!--                        <span v-else-if="$vuetify.breakpoint.width <= 940"> vs </span>-->
                        <span
                            v-else
                            style="padding: 0 6px !important"
                            class="date-remaining"
                            :class="[$vuetify.breakpoint.width <= 860 ? 'font11' : 'font13', event.leftUntilStart < 1 ? 'orangeText' : 'greenText']"
                        >
                            <!--                            <span class="greenText font13 text-center">-->
                            {{ utils.getDateRemaining(event.leftUntilStart, user.timeZone) }}
                            <!--                            </span>-->
                        </span>
                    </v-row>
                </v-col>
                <v-col class="pa-0 d-flex align-center justify-center flex-row">
                    <img v-if="event.ctaLogo" :src="'/teams/' + event.ctaLogo" class="logo" alt="team" />

                    <img v-else src="https://cdn.sportmonks.com/images/soccer/team_placeholder.png" class="logo" alt="team" />
                    <v-btn tag="a" class="ml-2" icon x-small @click="toggleFavoriteTeam('ctaId', event)" :disabled="event.ctaId in favoriteTeamProcessing">
                        <v-icon size="24px" v-if="!(event.ctaId in favoriteTeam)" color="grey lighten-1">mdi-star-outline</v-icon>

                        <v-icon size="24px" v-else color="yellow darken-3">mdi-star</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-row class="mx-0 mt-2">
                <v-col class="pl-7 py-0 pr-0 d-flex align-center justify-center flex-row">
                    <span class="team text-center">
                        {{ event.cthName }}
                    </span>
                </v-col>
                <v-col class="text-center pa-0 d-flex flex-column align-center justify-center" :style="'max-width:' + scoreWidth"></v-col>
                <v-col class="pr-7 py-0 pl-0 d-flex align-center justify-center flex-row">
                    <span class="team text-center">
                        {{ event.ctaName }}
                    </span>
                </v-col>
            </v-row>

            <v-row v-if="eventStats && (eventStats.red_away || eventStats.red_home)" class="mx-0 mt-0">
                <div class="container d-flex font20 font-weight-bold py-0">
                    <div class="left text-right">
                        <v-chip v-if="eventStats.red_home" class="px-1 red-cards font14 white--text bold" color="#d62828" label small style="min-width: 18px">
                            <span class="d-flex justify-center" style="width: 100%">
                                {{ eventStats.red_home }}
                            </span>
                        </v-chip>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="middle text-center px-0" :style="'width:' + scoreWidth"></div>
                    <div class="right text-left">
                        <v-chip v-if="eventStats.red_away" class="px-1 red-cards font14 white--text bold" color="#d62828" label small style="min-width: 18px">
                            <span class="d-flex justify-center" style="width: 100%">
                                {{ eventStats.red_away }}
                            </span>
                        </v-chip>
                        <span v-else>&nbsp;</span>
                    </div>
                </div>
            </v-row>
            <v-btn
                tag="a"
                fab
                absolute
                right
                icon
                @click="closeEventDialog"
                style=""
                :style="$vuetify.breakpoint.width <= 430 ? 'top: 0px; right: 0px' : 'top: 15px'"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-container>
    </v-card-title>
</template>

<style scoped>
    .logo {
        width: 75px;
        height: auto;
        object-fit: cover;
    }
    .date-remaining {
        font-size: 13px;
        text-align: center;
        //color: #6aa84f;
    }
    .team-wrapper {
    }

    .left {
        width: 50%;
    }

    .middle {
    }

    .right {
        width: 50%;
    }
    .font20 {
        font-size: 20px;
    }
    .score {
        font-size: 40px;
        color: #ff9900;
    }
    .ft-score {
        font-size: 32px;
    }

    .team {
        font-size: 14px;
    }
    @media only screen and (max-width: 600px) {
        .score {
            font-size: 32px;
        }
        .ft-score {
            font-size: 32px;
        }
        .team {
            font-size: 9px;
        }
    }
    .time {
        font-size: 14px;
    }
    .ft-time {
        font-size: 14px;
    }
    .team {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
</style>

<script>
    import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';
    import dateFnsLocaleEn from 'date-fns/locale/en-US';
    import dateFnsLocalePt from 'date-fns/locale/pt';

    export default {
        name: 'app-eventInfo',
        props: {},
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {
                prevScore: null,
            };
        },

        methods: {
            toggleFavoriteLeague: function (event) {
                const item = { clId: event.clId };

                this.$store.dispatch('LeagueModule/toggleFavoriteLeague', { item: item }, { root: true });
            },

            toggleFavoriteTeam: function (key, event) {
                let item = { ctId: event[key] };

                this.$store.dispatch('TeamModule/toggleFavoriteTeam', { item: item }, { root: true });
            },

            closeEventDialog() {
                this.$emit('closeEventDialog', {});
            },

            getTime(item) {
                if (!item.time) {
                    return this.$t('event.unavailable');
                }
                let time = item.time.toUpperCase();

                if (time === 'FT') {
                    time = this.$t('event.finished');
                }

                return time;
            },

            getPrevScore: function () {
                return this.prevScore;
            },

            setPrevScore: function (item, lastChangedScore, lastGoalAt) {
                if (this.prevScore === null || item.score !== lastChangedScore) {
                    this.prevScore = {
                        score: item.score,
                        lastChangedScore: lastChangedScore,
                        lastGoalAt: lastGoalAt,
                    };
                }
            },

            getScore(item) {
                if (!item.score) {
                    return '? - ?';
                }

                let prevScore = this.getPrevScore();

                let scoreToDisplay = item.score.replace('-', ' - ');
                let score = item.score.split('-');

                if (prevScore) {
                    let diffTime = (Date.now() - prevScore['lastGoalAt']) / 1000; //difference time in sec between current score and lastChangedScore

                    if (prevScore['score'] === item.score && diffTime > 20 && !item.is_scores_mismatch) {
                        return scoreToDisplay;
                    }

                    if (prevScore['score'] !== item.score) {
                        this.setPrevScore(item, prevScore['score'], Date.now());
                    }

                    if (!prevScore['score']) {
                        return scoreToDisplay;
                    }

                    prevScore = prevScore['score'] !== item.score ? prevScore['score'].split('-') : prevScore['lastChangedScore'].split('-');

                    if (prevScore[0] !== score[0]) {
                        return (
                            '<span><span class="redColorScore' +
                            (item.is_scores_mismatch ? ' redText' : '') +
                            '">' +
                            score[0] +
                            '</span><span class=""> - ' +
                            score[1] +
                            '</span></span>'
                        );
                    }

                    if (prevScore[1] !== score[1]) {
                        return (
                            '<span><span  class="">' +
                            score[0] +
                            ' - </span><span class="redColorScore' +
                            (item.is_scores_mismatch ? ' redText' : '') +
                            '">' +
                            score[1] +
                            '</span></span>'
                        );
                    }

                    // return scoreToDisplay;
                }

                if(item.is_scores_mismatch) {
                    const homeScores = JSON.parse(item.scores)
                        .map(entry => entry[1]?.split('-')[0]);

                    const firstHomeScore = homeScores[0];
                    const isHomeScoresDiff = homeScores.some(score => score !== firstHomeScore);

                    if (isHomeScoresDiff) {
                        return (
                            '<span class=""><span class="redColorScore redText">' +
                            score[0] +
                            '</span><span class=""> - ' +
                            score[1] +
                            '</span></span>'
                        );
                    }

                    return (
                        '<span  class=""><span  class="">' +
                        score[0] +
                        ' - </span><span class="redColorScore redText">' +
                        score[1] +
                        '</span></span>'
                    );
                }

                this.setPrevScore(item, item.score, 0);

                return scoreToDisplay;
            },
            isEmpty(value) {
                return _.isEmpty(value);
            },
            formatDballDate(date) {
                if (!(date instanceof Date)) {
                    date = zonedTimeToUtc(date, 'Europe/London'); //'Europe/London' here is our DB timezone
                }

                const now = new Date();
                const tomorrow = new Date();
                tomorrow.setDate(now.getDate() + 1);

                const isToday = date.toDateString() === now.toDateString();
                const isTomorrow = date.toDateString() === tomorrow.toDateString();

                let dateLocale = dateFnsLocaleEn;

                if (this.$i18n.locale === 'pt') {
                    dateLocale = dateFnsLocalePt;
                }

                let options = { locale: dateLocale };
                const timeZone = this.user.timeZone;

                if (isToday) {
                    return this.$t('event.today') + ', ' + formatInTimeZone(date, timeZone, 'H:mm', options);
                } else if (isTomorrow) {
                    return this.$t('event.tomorrow') + ', ' + formatInTimeZone(date, timeZone, 'H:mm', options);
                }

                return formatInTimeZone(date, timeZone, 'EEEE, MMM d, HH:mm', options);
            },
        },
        computed: {
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },

            favoriteLeagueProcessing: {
                get() {
                    return this.$store.getters['LeagueModule/getFavoriteLeagueProcessing'];
                },
                set(value) {
                    this.$store.commit('LeagueModule/setFavoriteLeagueProcessing', value);
                },
            },

            favoriteTeamProcessing: {
                get() {
                    return this.$store.getters['TeamModule/getFavoriteTeamProcessing'];
                },
                set(value) {
                    this.$store.commit('TeamModule/setFavoriteTeamProcessing', value);
                },
            },

            favoriteLeague: {
                get() {
                    return this.$store.getters['LeagueModule/getFavoriteLeague'];
                },
                set(value) {
                    this.$store.commit('LeagueModule/setFavoriteLeague', value);
                },
            },

            favoriteTeam: {
                get() {
                    return this.$store.getters['TeamModule/getFavoriteTeam'];
                },
                set(value) {
                    this.$store.commit('TeamModule/setFavoriteTeam', value);
                },
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            scoreWidth() {
                if (this.eventStats && this.event.mId === this.$const.DBALL_MARKET_LIVE) {
                    return '120px';
                }

                // if (this.$vuetify.breakpoint.width <= 940) {
                //     return '85px';
                // }

                if (this.event.leftUntilStart < 1) {
                    return '126px';
                }

                let leftUntilStart = this.event.leftUntilStart;

                let days = Math.floor(leftUntilStart / (60 * 24));
                let hour = Math.floor((leftUntilStart % (60 * 24)) / 60);
                let minutes = Math.floor((leftUntilStart % (60 * 24)) % 60);

                let width = 100;

                if (this.$vuetify.breakpoint.width < 400) {
                    width += 50;
                } else if (this.$vuetify.breakpoint.width < 500) {
                    width += 30;
                }

                if (days) {
                    if (days < 10) {
                        width += 35;
                    } else {
                        width += 40;
                    }
                }

                if (hour) {
                    if (hour < 10) {
                        width += 25;
                    } else {
                        width += 35;
                    }
                }

                if (minutes) {
                    if (minutes < 10) {
                        width += 15;
                    } else {
                        width += 20;
                    }
                }

                return width + 'px';
            },
        },
    };
</script>
